
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["funnel-demo-common","funnel-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Funnel__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.en.md?type=demo')
};